import { Box, Stack, Typography, useTheme } from '@mui/material';

// Components
import { BookmarkTypes, IBookmarkCompareCompany } from 'src/model/bookmark';

import { UnknownText } from 'src/utils/constants/config';
import FlagCountry from 'src/components/common/FlagCountry';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
// import { useTranslation } from 'react-i18next';
import BookmarkCardLayout from 'src/features/Bookmark/Common/BookmarkCardLayout';
import IconCompareCompany2 from 'src/asset/icons/compare-company-2.svg';
import IconCompareCompany3 from 'src/asset/icons/compare-company-3.svg';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';

interface ICompareBookmarkProps {
  dataBookmark: IBookmarkCompareCompany;
}

const CompareCompanyBookmarkCard = ({ dataBookmark }: ICompareBookmarkProps) => {
  const theme = useTheme();
  // const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClickBookmark = () => {
    let search = '';
    getArrayDefault(dataBookmark?.list_company_compare)
      .filter((company) => !isEmpty(company.id))
      .forEach((company) => (search += `companyIds=${company.id}&`));
    navigate({
      pathname: AuthRouteKeys.CompareCompany,
      search: search,
    });
  };

  return (
    <BookmarkCardLayout bookmarkType={BookmarkTypes.CompareCompany} data={dataBookmark}>
      <Stack direction={'column'} gap={1} onClick={handleClickBookmark}>
        <Typography color="text.secondary" variant="subtitle2">
          Companies Compare
        </Typography>
        <Stack direction="column" pl={4} position="relative">
          {getArrayDefault(dataBookmark.list_company_compare).map((company, index) => (
            <Stack
              key={`compare-company-${company.id}`}
              alignItems={'center'}
              spacing={1}
              direction="row"
              pt={index !== 0 ? 2 : 0}
            >
              <FlagCountry width={20} code={company.country_code} />
              <Typography color={theme.palette.secondary.main} variant="subtitle1">
                {company.name || UnknownText}
              </Typography>
            </Stack>
          ))}
          <Box
            position="absolute"
            mt={0}
            top="50%"
            left={theme.spacing(-0.5)}
            zIndex={100}
            bgcolor={theme.palette.background.default}
            display="flex"
            sx={{
              transform: 'translateY(-50%)',
            }}
          >
            <Typography color="text.secondary" variant="caption">
              vs
            </Typography>
          </Box>
          <Box
            component={'img'}
            height={getArrayDefault(dataBookmark?.list_company_compare).length === 2 ? 56 : 86}
            width={28}
            position="absolute"
            mt={0}
            top="50%"
            left={0}
            sx={{
              transform: 'translateY(-50%)',
            }}
            src={
              getArrayDefault(dataBookmark?.list_company_compare).length === 2
                ? IconCompareCompany2
                : IconCompareCompany3
            }
          />
        </Stack>
      </Stack>
    </BookmarkCardLayout>
  );
};
export default CompareCompanyBookmarkCard;
